export const CATEGORY_IMAGE_MAP: Record<string, { src: string; width: number; height: number }> = {
  'Bottle Service': { src: '/images/categories/wine.png', width: 81, height: 137 },
  'Menus & Signs': { src: '/images/categories/foods.png', width: 129, height: 137 },
  'Party Supplies': { src: '/images/categories/gifts.png', width: 117, height: 137 },
};

export const CATEGORY_URL_MAP: Record<string, string> = {
  'Bottle Service': '/bottle-service',
  'Menus & Signs': '/menus-and-signs',
  'Party Supplies': '/party-supplies',
};

export const LABEL_NORMALIZATION_MAP: Record<string, string> = {
  wine: 'Wine',
  spirits: 'Spirits',
  beer: 'Beer & Seltzers',
  foods: 'Finer Foods',
  cigars: 'Cigars',
  gifts: 'Gifts & Accessories',
};
